import { getSnapshot, mergeOptions } from '@/constantes/helpers'
import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

const docRef = (id_franquicia) => db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(id_franquicia)
    .collection(FS_COLLECTIONS.CATALOGOS).doc(FS_COLLECTIONS.CATEGORIAS)

const store = {
    state: {
        categorias: {},
    },
    getters: {
        categorias: state => {
            return state.categorias
        },
    },
    mutations: {
        ASIGNA_CATEGORIAS(state, categorias) {
            state.categorias = categorias
        },
    },
    actions: {
        async actualizarCategoria({ getters }, payload) {

            const { categoria } = payload

            return await docRef(getters.franquicia.id).set(categoria, mergeOptions)

        },
        obtenerCategorias({ getters, commit }) {

            return new Promise(resolve => {

                if(Object.keys(getters.categorias).length) resolve()

                docRef(getters.franquicia.id).onSnapshot(doc => {
                    commit('ASIGNA_CATEGORIAS', getSnapshot(doc))
                    resolve()
                })

            })

        },
        async eliminarConcepto({getters},payload){
            
            const {id_categoria, id_concepto} = payload

            const campoBorrar = {
                [`${id_categoria}.conceptos.${id_concepto}`]:firebase.firestore.FieldValue.delete()
            }

            return await docRef(getters.franquicia.id).update(campoBorrar)

        },
        async eliminarCategoria({getters},payload){
            
            const {id_categoria} = payload

            const campoBorrar = {
                [`${id_categoria}`]:firebase.firestore.FieldValue.delete()
            }

            return await docRef(getters.franquicia.id).update(campoBorrar)

        }
    }
}

export default store



// WEBPACK FOOTER //
// ./src/store/categorias/index.js